import Lookbook from "@/components/Lookbook";

export default function LookbookPage() {
  return (
    <div className="pt-16" data-testid="lookbook-page">
      <Lookbook />
    </div>
  );
}
